import MatchDetailsTeam from "./MatchDetailsTeam.jsx"

export default function MatchDetailsTeamB({match}) {
  const defaultBadgeThumb = "https://bolaodacopa.com/images/default_badge_thumb.png"

  return (
    <MatchDetailsTeam
      teamId={match.team_b_id}
      teamName={match.team_b_name}
      teamBadgeThumb={match.team_b_badge_thumb || defaultBadgeThumb}
      isWinner={match.is_ended && (match.team_b_score > match.team_a_score)}
      tournamentId={match.tournament_id}
    />
  )
}
